import initProductsSlider from '../sliders/products-slider';

const $doc = $(document);

/**
 * Init Related Products
 * @return {[type]} [description]
 */
const initRelatedProducts = () => {
	const $relatedProductsSection = $('.js-related-products');
	const $relatedProductsContainer = $('.js-related-products-cotnainer');
	const baseUrl = $relatedProductsSection.data('base-url');
	const productId = $relatedProductsSection.data('product-id');
	const sectionId = $relatedProductsSection.data('section-id');
	const limit = $relatedProductsSection.data('limit');
	const requestUrl = baseUrl + '?section_id=' + sectionId + '&product_id=' + productId + "&limit=" + limit;

	$.ajax({
		url: requestUrl,
		type: 'GET',
		dataType: 'html',
		success: function(data) {
			const $dataContainer = jQuery('<div/>');

			$dataContainer.html(data);

			$relatedProductsContainer.html($dataContainer.find('.js-related-products-cotnainer').html());

			initProductsSlider($relatedProductsContainer.find('.js-slider .slider__slides'));
		}
	});
}

initRelatedProducts();

/**
 * Listen for changes done in the Theme Editor
 */
$doc.on('shopify:section:load', function(event) {
	if (event.detail.sectionId === 'related-products') {
		initRelatedProducts();
	}
});
